import baseApi from ".";
import createQueryFn from "../createQueryFn";
import api from "api";
import { GetAllCustomersRequest, GetAllCustomersResponse } from "api/customers/getAllCustomers";

const customersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCustomers: builder.query<GetAllCustomersResponse, GetAllCustomersRequest>({
      queryFn: createQueryFn(api.customers.getAllCustomers),
      providesTags: [{ type: "Company", id: "LIST" }],
    }),
  }),
});

export const {
  useGetAllCustomersQuery,
} = customersApi;

export default customersApi;
